module.exports = [
  'Academic Assessment',
  'ACT',
  'Addiction/Substance Abuse',
  'Art Therapy',
  'Autism',
  'Behavioral Analysis',
  'CBT',
  'Child and Adolescent Mental Health',
  'Clinical Health Psychology',
  'Couples',
  'DBT',
  'EMDR',
  'Families',
  'Geriatric Mental Health',
  'Grief',
  'Hypnotherapy',
  'Motivational Interviewing',
  'Neuropsychological Assessment',
  'Perinatal Mental Health',
  'Play Therapy',
  'Psychoanalytic',
  'Rehabilitation',
  'Serious Mental Illness',
  'Sex and Sexuality',
  'Trauma',
];
